import type { FaireProductEntity } from "../../entity_types/product";

export const p_pcaaab5az6: FaireProductEntity = {
  token: "p_pcaaab5az6",
  type: "product",
  name: "Spice and Wolf, Vol. 14",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/a2d2f9f672a619685581544ce3b7b33765ae4dd8ac11b3493bc7b1dd302070a6.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/88214c4a6ed07f219bf36fd9bdb875f9be328d913ea8a78d7cb33161090fba1c.jpeg"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nPreviously, Lawrence and Holo traveled to the town of Svernel in order to meet with the Myuri Mercenary Company and find out more about Holo's past companions and her home. But now Lawrence has gotten completely caught up in the political strife of the Debau Trading Company. It all surrounds the Debau Company's desire to issue a new currency, with which they have apparent plans to unite the surrounding northern region. For their aim, the Debau Company needs to acquire raw ore and materials but this has caused their opponents to increase their own efforts to foil this plan. In the middle of all this, Lawrence is trusted with delivering a forbidden text detailing the necessary mining techniques to the trading company's executive, Hilde Schnau but will it really go so smoothly?!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:32.721Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
